import React from 'react';
import styled from 'astroturf/react';

import routes from 'js/core_pre_webpack/routes';
import $image_url from 'js/utils/image_url';
import { currentUser } from 'js/utils/user';
import { uploadUrl } from './uploadUrl';
import PremiumLock from 'js/premium/PremiumLock';
import trackClick from 'js/utils/trackClick';
import _Header from "ToolsMenu-Header.module.scss!=!astroturf/inline-loader?style=1!/var/lib/jenkins-code/academia-app/app/assets/javascripts/header/FocusedNav/ToolsMenu.tsx?styleId=Header";
import _HighlightList from "ToolsMenu-HighlightList.module.scss!=!astroturf/inline-loader?style=1!/var/lib/jenkins-code/academia-app/app/assets/javascripts/header/FocusedNav/ToolsMenu.tsx?styleId=HighlightList";
import _Description from "ToolsMenu-Description.module.scss!=!astroturf/inline-loader?style=1!/var/lib/jenkins-code/academia-app/app/assets/javascripts/header/FocusedNav/ToolsMenu.tsx?styleId=Description";
import _ButtonishAnchor from "ToolsMenu-ButtonishAnchor.module.scss!=!astroturf/inline-loader?style=1!/var/lib/jenkins-code/academia-app/app/assets/javascripts/header/FocusedNav/ToolsMenu.tsx?styleId=ButtonishAnchor";
import _ProminentLinkIcon from "ToolsMenu-ProminentLinkIcon.module.scss!=!astroturf/inline-loader?style=1!/var/lib/jenkins-code/academia-app/app/assets/javascripts/header/FocusedNav/ToolsMenu.tsx?styleId=ProminentLinkIcon";
import _ProminentLinkIconWrapper from "ToolsMenu-ProminentLinkIconWrapper.module.scss!=!astroturf/inline-loader?style=1!/var/lib/jenkins-code/academia-app/app/assets/javascripts/header/FocusedNav/ToolsMenu.tsx?styleId=ProminentLinkIconWrapper";
import _NotificationDot from "ToolsMenu-NotificationDot.module.scss!=!astroturf/inline-loader?style=1!/var/lib/jenkins-code/academia-app/app/assets/javascripts/header/FocusedNav/ToolsMenu.tsx?styleId=NotificationDot";
import _ProminentLink from "ToolsMenu-ProminentLink.module.scss!=!astroturf/inline-loader?style=1!/var/lib/jenkins-code/academia-app/app/assets/javascripts/header/FocusedNav/ToolsMenu.tsx?styleId=ProminentLink";
import _DescriptionList from "ToolsMenu-DescriptionList.module.scss!=!astroturf/inline-loader?style=1!/var/lib/jenkins-code/academia-app/app/assets/javascripts/header/FocusedNav/ToolsMenu.tsx?styleId=DescriptionList";
import _Subheader from "ToolsMenu-Subheader.module.scss!=!astroturf/inline-loader?style=1!/var/lib/jenkins-code/academia-app/app/assets/javascripts/header/FocusedNav/ToolsMenu.tsx?styleId=Subheader";


const Header = /*#__PURE__*/styled("h2", null, {
  displayName: "Header",
  styles: _Header
});

const HighlightList = /*#__PURE__*/styled("ul", null, {
  displayName: "HighlightList",
  styles: _HighlightList
});

const Description = /*#__PURE__*/styled("p", null, {
  displayName: "Description",
  styles: _Description
});

const ButtonishAnchor = /*#__PURE__*/styled("a", null, {
  displayName: "ButtonishAnchor",
  styles: _ButtonishAnchor
});

const ProminentLinkIcon = /*#__PURE__*/styled("img", null, {
  displayName: "ProminentLinkIcon",
  styles: _ProminentLinkIcon
});

const ProminentLinkIconWrapper = /*#__PURE__*/styled("span", null, {
  displayName: "ProminentLinkIconWrapper",
  styles: _ProminentLinkIconWrapper
});

const NotificationDot = /*#__PURE__*/styled("div", null, {
  displayName: "NotificationDot",
  styles: _NotificationDot
});

const ProminentLink = /*#__PURE__*/styled(ButtonishAnchor, null, {
  displayName: "ProminentLink",
  styles: _ProminentLink
});

const DescriptionList = /*#__PURE__*/styled("ul", null, {
  displayName: "DescriptionList",
  styles: _DescriptionList
});

const Subheader = /*#__PURE__*/styled("h3", null, {
  displayName: "Subheader",
  styles: _Subheader
});

export type Props = {
  startSearch: () => void;
  hasUnseenClaimablePapers?: boolean;
  hasUnseenUploadableStubs?: boolean;
};

const ToolsMenu = ({
  startSearch,
  hasUnseenClaimablePapers = false,
  hasUnseenUploadableStubs = false,
}: Props) => {
  const handleOnUploadClick = () => {
    trackClick({
      source: 'nav-bar-tools--upload-button',
    });
  };

  return (
    <>
      <Header>Explore Academia products</Header>
      <HighlightList>
        <li>
          <ProminentLink
            href={uploadUrl({
              hasUnseenUploadableStubs,
              hasUnseenClaimablePapers,
              trigger: 'tools',
            })}
            onClick={handleOnUploadClick}
          >
            <ProminentLinkIcon
              src={$image_url('header/focused/up_arrow.svg')}
            />
            <div>
              <div>
                Upload
                {(hasUnseenClaimablePapers || hasUnseenUploadableStubs) && (
                  <NotificationDot />
                )}
              </div>
            </div>
          </ProminentLink>
        </li>

        <li>
          <ProminentLink
            href={routes.academia_journals_url({
              from_navbar: true,
              trigger: 'tools',
              source: 'tools',
            })}
          >
            <ProminentLinkIcon
              src={$image_url('header/focused/open_book.svg')}
            />
            <div>
              <div>Academia.edu Journals</div>
            </div>
          </ProminentLink>
        </li>

        <li>
          <ProminentLink
            {...(currentUser?.premium
              ? { onClick: startSearch, role: 'button' }
              : {
                  href: routes.upgrade_url({
                    feature: 'search',
                    from_navbar: true,
                    trigger: 'tools',
                  }),
                })}
          >
            <ProminentLinkIcon
              src={$image_url('header/focused/magnifying_glass.svg')}
            />
            <div>Advanced Search</div>
            <PremiumLock />
          </ProminentLink>
        </li>
        <li>
          <ProminentLink
            href={routes.research_index_url({
              from_navbar: true,
              trigger: 'tools',
            })}
          >
            <ProminentLinkIcon
              src={$image_url('header/focused/packed_folder_uninverted.svg')}
            />
            <div>PDF Packs</div>
            <PremiumLock />
          </ProminentLink>
        </li>
        <li>
          <ProminentLink
            href={
              currentUser?.premium
                ? routes.saved_searches_url({
                    from_navbar: true,
                    trigger: 'tools',
                  })
                : routes.upgrade_url({
                    feature: 'SAVED_SEARCH',
                    from_navbar: true,
                    trigger: 'tools',
                  })
            }
          >
            <ProminentLinkIcon
              src={$image_url('header/focused/alert_bell.svg')}
            />
            <div>Search Alerts</div>
            <PremiumLock />
          </ProminentLink>
        </li>
        <li>
          <ProminentLink
            href={routes.courses_url({ from_navbar: true, trigger: 'tools' })}
          >
            <ProminentLinkIcon src={$image_url('header/focused/courses.svg')} />
            <div>Courses</div>
          </ProminentLink>
        </li>
      </HighlightList>
      <Header>Accelerate your research</Header>
      <DescriptionList>
        <li>
          <ButtonishAnchor
            href={routes.recommendations_url({
              from_navbar: true,
              trigger: 'tools',
            })}
          >
            <Subheader>Improve your recommendations</Subheader>
            <Description>Improve on-site recommendations</Description>
          </ButtonishAnchor>
        </li>
        <li>
          <ButtonishAnchor
            href={routes.bookmarks_url({
              from_navbar: true,
              trigger: 'tools',
            })}
          >
            <Subheader>Bookmarks</Subheader>
            <Description>Your recent reads and saved papers</Description>
          </ButtonishAnchor>
        </li>
        <li>
          <ButtonishAnchor
            href={
              currentUser?.premium
                ? routes.bookmarks_url({
                    from_navbar: true,
                    trigger: 'tools',
                  })
                : routes.upgrade_url({
                    feature: 'translations',
                    from_navbar: true,
                    trigger: 'tools',
                  })
            }
          >
            <Subheader>
              <div>Translation</div>
              <PremiumLock />
            </Subheader>
            <Description>Discover and translate research</Description>
          </ButtonishAnchor>
        </li>
      </DescriptionList>
      <Header>Advance your Career</Header>
      <DescriptionList>
        <li>
          <ButtonishAnchor
            href={
              currentUser?.premium
                ? routes.portfolio_preview_url({
                    from_navbar: true,
                    trigger: 'tools',
                  })
                : routes.portfolio_creation_url({
                    from_navbar: true,
                    trigger: 'tools',
                  })
            }
          >
            <Subheader>
              <div>Personal Website</div>
              <PremiumLock />
            </Subheader>
            <Description>Showcase your academic work</Description>
          </ButtonishAnchor>
        </li>
      </DescriptionList>
    </>
  );
};

export default ToolsMenu;
